import type { Coords } from 'google-map-react'
import Image from 'next/image'
import React from 'react'

import { Div, TDivProps } from 'elements/layout/Div'

export const GMapDivChild: TFCC<TDivProps & Coords> = Div

export type TSimpleMarkerProps = Coords & {
  onClick: (point: Coords) => void
  markerImg?: string
}

export const SimpleMarker: TFC<TSimpleMarkerProps> = ({ lat, lng, onClick, markerImg = '/img/map/place_big.png' }) => (
  <GMapDivChild lat={lat} lng={lng} w="30px" h="30px" onClick={() => onClick({ lat, lng })}>
    <Image src={markerImg} width="100%" height="100%" alt="trans:community:community.prayer.map" />
  </GMapDivChild>
)
